<template>
  <div class="container p-2" v-if="tes_id != '' && DateStep.Step1 != ''">
    <div class="container p-2">
      <div class="alert alert-primary text-center" role="alert">
        <div class="progress" v-if="_getStepIndex <= 6">
          <div
            class="progress-bar"
            role="progressbar"
            style="width: 90%"
            aria-valuenow="25"
            aria-valuemin="0"
            aria-valuemax="100"
          >
            90%
          </div>
        </div>
        <div class="progress" v-else>
          <div
            class="progress-bar"
            role="progressbar"
            style="width: 100%"
            aria-valuenow="25"
            aria-valuemin="0"
            aria-valuemax="100"
          >
            100%
          </div>
        </div>
        <h3 class="p-3">ขั้นตอนที่ 5</h3>
        ข้อมูลผู้ปกครอง ชำระเงิน และนัดวัดตัวตัดเสื้อผ้า...
      </div>

      <div class="alert alert-secondary" role="alert">
        <div class="col my-4 text-center">
          <h1><b>ข้อมูลผู้ปกครอง</b></h1>
          <h2 class="text-danger">
            รับสมัครปีการศึกษา {{ getDataFrom6.select_year }}
          </h2>
          <h6 class="text-danger">
            กรุณากรอกข้อมูลให้ครบทั้งหมด การสมัครเรียนแบ่งออกเป็น 5 ส่วน <br />
            <b>
              หากกรอกข้อมูลไม่ครบส่วนใดส่วนหนึ่ง
              จะถือว่าการสมัครเรียนหรือจองที่เรียนไม่สมบูรณ์</b
            ><br />
            หากไม่มีข้อมูลให้ใส่เครื่องหมาย<br />
            พบปัญหาเกี่ยวกับการกรอกข้อมูลติดต่อ 053-213061 ต่อ 112
          </h6>
        </div>
        <form @submit.prevent="SetStepStatus(7), thaiDate()">
          <div class="row form-group my-5">
            <div class="row">
              <div class="col-lg-12">
                <fieldset class="rounded-4 border border-primary p-3 mb-5">
                  <legend class="float-none w-auto px-3 fw-bold">
                    <h3 class="text-primary"><b> ชื่อผู้ปกครอง</b></h3>
                  </legend>
                  <div class="row form-group d-flex justify-content-center">
                    <div class="col-lg-2">
                      <h6 class="text-left" style="font-weight: bold">
                        <div class="d-flex">
                          ความสัมพันธ์
                          <p style="color: red">*</p>
                        </div>
                      </h6>
                      <select
                        class="form-select"
                        aria-label="Default select example"
                        v-model="stu_sub_relationID"
                        @change="stu_sub_relationIF"
                        required
                      >
                        <option
                          value=""
                          selected
                          disabled
                          style="background-color: lightgray"
                        >
                          -
                        </option>
                        <option value="1">บิดา</option>
                        <option value="2">มารดา</option>
                        <option value="0">อื่นๆ</option>
                      </select>
                    </div>
                    <div class="col-lg-2" v-if="stu_sub_relationID == '0'">
                      <h6 class="text-left" style="font-weight: bold">
                        <div class="d-flex">
                          (ระบุ)
                          <p style="color: red">*</p>
                        </div>
                      </h6>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="ความสัมพันธ์"
                        v-model="getDataFrom6.stu_sub_relation"
                        required
                      />
                    </div>
                    <div
                      class="col-lg-2 my-3"
                      v-else-if="stu_sub_relationID != '0'"
                    ></div>
                    <div class="col-lg-6 my-3"></div>
                  </div>
                  <div class="row form-group d-flex justify-content-center">
                    <div class="col-lg-2 my-3">
                      <h6 class="text-left" style="font-weight: bold">
                        <div class="d-flex">
                          คำนำหน้า
                          <p style="color: red">*</p>
                        </div>
                      </h6>
                      <select
                        class="form-select"
                        aria-label="Default select example"
                        name="pre_id"
                        id="pre_id"
                        v-model="getDataFrom6.stu_sub_prename"
                        required
                      >
                        <option value="" disabled selected></option>
                        <option
                          v-for="item in getDataPrename"
                          :key="item.pre_id"
                          :value="`${item.pre_id}`"
                        >
                          {{ item.pre_prename }}
                        </option>
                      </select>
                    </div>
                    <div class="col-lg-4 my-3">
                      <h6 class="text-left" style="font-weight: bold">
                        <div class="d-flex">
                          ชื่อ
                          <p style="color: red">*</p>
                        </div>
                      </h6>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="ชื่อ"
                        maxlength="30"
                        v-model="getDataFrom6.stu_sub_fname"
                        required
                      />
                    </div>
                    <div class="col-lg-4 my-3">
                      <h6 class="text-left" style="font-weight: bold">
                        <div class="d-flex">
                          นามสกุล
                          <p style="color: red">*</p>
                        </div>
                      </h6>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="นามสกุล"
                        maxlength="30"
                        v-model="getDataFrom6.stu_sub_lname"
                        required
                      />
                    </div>
                  </div>
                </fieldset>
                <fieldset class="rounded-4 border border-primary p-3 mb-5">
                  <legend class="float-none w-auto px-3 fw-bold">
                    <h3 class="text-primary"><b> ที่อยู่ผู้ปกครอง</b></h3>
                  </legend>
                  <div class="row form-group d-flex justify-content-center">
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left" style="font-weight: bold">
                        <div class="d-flex">
                          บ้านเลขที่
                          <p style="color: red">*</p>
                        </div>
                      </h6>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="บ้านเลขที่"
                        maxlength="35"
                        v-model="getDataFrom6.stu_shomeid"
                        required
                      />
                    </div>
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">หมู่บ้าน</div>
                      </h6>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="หมู่บ้าน"
                        maxlength="30"
                        v-model="getDataFrom6.stu_svillage"
                      />
                    </div>
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">ซอย</div>
                      </h6>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="ซอย"
                        maxlength="30"
                        v-model="getDataFrom6.stu_ssoi"
                      />
                    </div>
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">ถนน</div>
                      </h6>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="ถนน"
                        maxlength="30"
                        v-model="getDataFrom6.stu_sroad"
                      />
                    </div>
                  </div>
                  <div class="row form-group d-flex justify-content-center">
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left" style="font-weight: bold">
                        <div class="d-flex">
                          จังหวัด
                          <p style="color: red">*</p>
                        </div>
                      </h6>
                      <select
                        class="form-select"
                        aria-label="Default select example"
                        v-model="getDataFrom6.stu_sprovince"
                        @change="selectProvince()"
                        required
                      >
                        <option
                          value=""
                          selected
                          disabled
                          style="background-color: lightgray"
                        >
                          -
                        </option>
                        <option
                          v-for="item in getDataProvince"
                          :key="item.pro_code"
                          :value="item.pro_code"
                        >
                          {{ item.pro_name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left" style="font-weight: bold">
                        <div class="d-flex">
                          อำเภอ
                          <p style="color: red">*</p>
                        </div>
                      </h6>
                      <select
                        class="form-select"
                        aria-label="Default select example"
                        v-model="this.getDataFrom6.stu_sdistrict"
                        @change="selectDistrict()"
                        required
                      >
                        <option
                          value=""
                          selected
                          disabled
                          style="background-color: lightgray"
                        >
                          -
                        </option>
                        <option
                          v-for="item in getDataDistrict"
                          :key="item.dis_id"
                          :value="item.dis_id"
                        >
                          {{ item.dis_name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left" style="font-weight: bold">
                        <div class="d-flex">
                          ตำบล
                          <p style="color: red">*</p>
                        </div>
                      </h6>
                      <select
                        class="form-select"
                        aria-label="Default select example"
                        v-model="getDataFrom6.stu_slocality"
                        @change="loadPostCode('SLocality')"
                        required
                      >
                        <option
                          value=""
                          selected
                          disabled
                          style="background-color: lightgray"
                        >
                          -
                        </option>
                        <option
                          v-for="item in getDataLocality"
                          :key="item.loc_id"
                          :value="item.loc_id"
                        >
                          {{ item.loc_name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left" style="font-weight: bold">
                        <div class="d-flex">
                          รหัสไปรษณีย์
                          <p style="color: red">*</p>
                        </div>
                      </h6>
                      <input
                        type="text"
                        class="form-control IsNumber"
                        placeholder="รหัสไปรษณีย์"
                        maxlength="5"
                        inputmode="numeric"
                        v-model="getDataFrom6.stu_spostcode"
                        required
                      />
                    </div>
                  </div>
                </fieldset>
                <fieldset class="rounded-4 border border-primary p-3 mb-5">
                  <legend class="float-none w-auto px-3 fw-bold">
                    <h3 class="text-primary">
                      <b> ข้อมูลหอพัก/รถรับส่งนักเรียน</b>
                    </h3>
                  </legend>
                  <div class="row form-group d-flex justify-content-center">
                    <router-link
                      :to="'/MapDormitory'"
                      target="_blank"
                      class="col-6"
                    >
                      <button class="col-12 btn btn-primary" type="button">
                        ดูข้อมูลหอพักเพิ่มเติม
                      </button>
                    </router-link>
                    <button
                      class="col-6 btn btn-success"
                      type="button"
                      @click="showModalBusForStudent"
                    >
                      ดูข้อมูลรถรับส่งนักเรียนเพิ่มเติม
                    </button>
                  </div>
                </fieldset>
                <fieldset
                  class="rounded-4 border border-primary p-3 mb-5"
                  v-if="this.Cardstatus == true"
                >
                  <legend class="float-none w-auto px-3 fw-bold">
                    <h3 class="text-primary"><b> รูปแบบบัตรประชาชน</b></h3>
                  </legend>
                  <input
                    type="radio"
                    class="btn btn-light btn-check"
                    name="CardID"
                    id="CardID1"
                    value="S"
                    v-model="CardID"
                  />
                  <label
                    class="btn btn-outline-secondary col-lg-2 mx-2 mb-3"
                    for="CardID1"
                    >บัตรประชาชนปกติ
                  </label>
                  <input
                    type="radio"
                    class="btn btn-light btn-check"
                    name="CardID"
                    id="CardID2"
                    value="P"
                    v-model="CardID"
                  />
                  <label
                    class="btn btn-outline-danger col-lg-2 mx-2 mb-3"
                    for="CardID2"
                    >บัตรชมพู
                  </label>
                  <input
                    type="radio"
                    class="btn-check"
                    name="CardID"
                    id="CardID3"
                    value="B"
                    v-model="CardID"
                  />
                  <label
                    class="btn btn-outline-primary col-lg-2 mx-2 mb-3"
                    for="CardID3"
                    >บัตรฟ้า
                  </label>
                  <input
                    type="radio"
                    class="btn-check"
                    name="CardID"
                    id="CardID4"
                    value="N"
                    v-model="CardID"
                  />
                  <label
                    class="btn btn-outline-dark col-lg-2 mx-2 mb-3"
                    for="CardID4"
                    >ไม่มีบัตร
                  </label>
                </fieldset>
              </div>
              <!-- {{ getDataFrom6 }} <br /> -->
              <!-- {{ getDataFrom2 }} <br /> -->
              <!-- {{ getDatafinanceBillNoti }} <br /> -->
              <!-- {{ getDataStudentTest }} -->
              <!-- {{ this.getDataFrom.stu_card_id.toString()[0] }} -->
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div
                class="col"
                v-if="getqrcodeChkStatusPay.status != 'Paysuccess'"
              >
                <div class="d-inline-flex p-2" style="float: left">
                  <button
                    type="button"
                    class="btn btn-primary"
                    v-on:click="SetStepStatusback(5)"
                  >
                    <font-awesome-icon :icon="['fas', 'backward']" /> ย้อนกลับ
                  </button>
                </div>
                <div class="d-inline-flex p-2" style="float: right">
                  <button type="submit" class="btn btn-primary">
                    ถัดไป <font-awesome-icon :icon="['fas', 'forward']" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div
          class="modal fade"
          id="exampleModal"
          tabindex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div v class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content mt-5">
              <div class="d-flex justify-content-end">
                <button
                  type="button"
                  class="btn btn-danger"
                  @click="closeExampleModal()"
                >
                  ✕
                </button>
              </div>
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">
                  รายละเอียดค่าเล่าเรียน ของ
                  {{ getDataStudent_Test.stu_fname }}
                  {{ getDataStudent_Test.stu_lname }}
                  <br />
                  ระดับชั้น :
                  <span
                    v-for="item in filterEducateLevelsix"
                    :key="item.cla_id"
                    :value="`${item.cla_id}`"
                  >
                    {{ item.cla_name }}</span
                  >
                  <br />
                  สาขา :
                  <span
                    v-for="item in filterDepartMentStusix"
                    :key="item.sdep_id"
                    :value="`${item.sdep_id}`"
                  >
                    {{ item.sdep_name }}</span
                  >
                  <br />
                  แผนการเรียน :
                  <span
                    v-for="item in filterDataVersion"
                    :key="item.ver_id"
                    :value="`${item.ver_id}`"
                  >
                    {{ item.ver_description }}</span
                  >
                  <br />
                  ประเภทการสมัคร :
                  <span v-if="getDataStudent_Test.cap_id === '-'"> - </span>

                  <span
                    v-else
                    v-for="item in filterDataBorrowStusix"
                    :key="item.bt_id"
                    :value="item.bt_id + '|' + item.bn_id"
                  >
                    {{ item.bn_name }}
                  </span>
                </h5>
              </div>
              <div class="modal-body" v-if="this.filterDataBorrowStusix != ''">
                <div>
                  <input
                    type="radio"
                    class="btn-check"
                    name="options-outlined"
                    id="btn-check-outlined1"
                    value="1"
                    v-model="selectPay"
                    @change="Pay_All_select()"
                  />
                  <label
                    class="btn btn-outline-primary col-lg-2 mx-2 mb-3"
                    for="btn-check-outlined1"
                    >ชำระทั้งหมด
                  </label>
                  <input
                    type="radio"
                    class="btn-check"
                    name="options-outlined"
                    id="btn-check-outlined2"
                    value="2"
                    v-model="selectPay"
                    @change="Pay_All_select()"
                  />
                  <label
                    class="btn btn-outline-primary col-lg-2 mb-3"
                    for="btn-check-outlined2"
                  >
                    ผ่อนชำระ
                  </label>
                  <div>
                    <table class="table">
                      <thead class="table-primary">
                        <tr class="text-center">
                          <th scope="col">#</th>
                          <th scope="col" class="text-start">รายการ</th>
                          <th scope="col">จำนวนเงิน</th>
                        </tr>
                      </thead>
                      <tbody v-if="selectPay == 1">
                        <tr
                          v-for="(item, index) in filterDataSignupPayManualsix"
                          :key="index"
                        >
                          <td class="text-center">{{ index + 1 }}</td>
                          <td>{{ item.txt_content }}</td>
                          <td class="text-end">
                            {{
                              parseFloat(item.pay_full)
                                .toFixed(2)
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td class="text-center"><h5>รวม</h5></td>
                          <td></td>
                          <td class="text-end">
                            <h5 class="text-danger fw-bold">
                              {{ getTotal() }} บาท
                            </h5>
                          </td>
                        </tr>
                      </tbody>
                      <tbody v-if="selectPay == 2">
                        <tr
                          v-for="(item, index) in filterDataSignupPayManualsix"
                          :key="index"
                        >
                          <td class="text-center">{{ index + 1 }}</td>
                          <td>{{ item.txt_content }}</td>
                          <td class="text-end">
                            {{
                              parseFloat(item.pay_period)
                                .toFixed(2)
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td class="text-center"><h5>รวม</h5></td>
                          <td></td>
                          <td class="text-end">
                            <h5 class="text-danger fw-bold">
                              {{ getTotal() }} บาท
                            </h5>
                          </td>
                        </tr>
                        <br />
                        <tr>
                          <th
                            colspan="3"
                            class="text-center h4 text-danger"
                            style="background-color: yellow"
                          >
                            *** สำหรับงวดต่อไปให้ผู้สมัครติดต่อกับ
                            งานการเงินด้วยตนเอง ***
                          </th>
                        </tr>
                      </tbody>
                      <tbody>
                        <br />
                        <tr>
                          <th colspan="3" class="text-danger">
                            <span>
                              ** กรุณาติ๊กเลือกเพื่อดำเนินการชำระเงิน **
                            </span>
                          </th>
                        </tr>
                        <tr>
                          <th
                            colspan="3"
                            class="text-danger"
                            style="background-color: rgb(255, 225, 255)"
                          >
                            <input
                              type="checkbox"
                              v-model="conditionSelectPay"
                              @change="conditionSell()"
                            />
                            <span>
                              การชำระเงินค่าเรียนแล้ว
                              ขาดคุณสมบัติหรือไม่ศึกษาต่อ ทางวิทยาลัยฯ
                              ขอสงวนสิทธิ์ไม่คืนเงินในทุกกรณี</span
                            >
                          </th>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="modal-body" v-else>
                <div class="text-center text-danger">
                  <span>
                    ทุนที่นักศึกษาเลือกไว้เต็มจำนวนแล้ว กรุณาเลือกทุนใหม่
                    ในขั้นตอนที่ 1</span
                  >
                </div>
              </div>
              <div
                class="modal-footer"
                v-if="this.filterDataBorrowStusix != ''"
              >
                <button
                  type="button"
                  class="btn btn-warning"
                  @click="closeExampleModal()"
                >
                  แก้ไขข้อมูล
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  :disabled="SelectedPay"
                  @click.prevent="
                    QRPay(),
                      Pay_All_select(),
                      generateQRCode(TextQrcode),
                      checkStatPay()
                  "
                >
                  ชำระค่าเล่าเรียน
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          class="modal fade"
          id="exampleModalPayment"
          tabindex="-1"
          aria-labelledby="exampleModalLabelPayment"
          aria-hidden="true"
        >
          <div v class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title font-weight-bold">
                    QR Code สำหรับชำระเงิน
                  </h5>
                </div>
                <div class="container p-0 m-0">
                  <div
                    class="text-center"
                    style="
                      padding: 20px;
                      width: 300px;
                      height: 80px;
                      background-color: #0e3d67;
                      margin-top: 20px;
                      margin-left: auto;
                      margin-right: auto;
                      position: relative;
                    "
                  >
                    <img
                      :src="previewImage"
                      style="width: 150px; height: 50px"
                    />
                  </div>
                  <div
                    style="
                      border: 6px solid #0e3d67;
                      border-width: thick;
                      width: 300px;
                      height: auto;
                      margin-left: auto;
                      margin-right: auto;
                      text-align: center;
                    "
                  >
                    <br />
                    <div v-if="ShowQRPay">
                      <p
                        style="
                          font-size: 14px;
                          font-weight: bold;
                          color: red;
                          text-align: center;
                        "
                        v-for="item in filterDataPrename"
                        :key="item.pre_id"
                        :value="`${item.pre_id}`"
                      >
                        QR code นี้ใช้สำหรับ {{ item.pre_prename }}
                        {{ getDataStudent_Test.stu_fname }}
                        {{ getDataStudent_Test.stu_lname }}
                      </p>
                    </div>
                    <br />
                    <div class="embed-responsive embed-responsive-16by9">
                      <div class="text-center">
                        <canvas ref="qrcodeCanvas"></canvas>
                      </div>
                    </div>
                    <br />
                    <div v-if="ShowQRPay">
                      <span
                        style="font-size: 14px; font-weight: bold"
                        v-for="item in filterDataPrename"
                        :key="item.pre_id"
                        :value="`${item.pre_id}`"
                      >
                        ชื่อ : {{ item.pre_prename }}
                        {{ getDataStudent_Test.stu_fname }}
                        {{ getDataStudent_Test.stu_lname }}
                      </span>
                      <br />
                      <span style="font-size: 14px; font-weight: bold">
                        รหัสผู้สมัคร : {{ getDataFrom6.tes_id }}
                      </span>
                      <br />
                      <span
                        style="font-size: 18px; font-weight: bold; color: red"
                      >
                        ยอดเงินชำระ : {{ payed_total }} บาท <br />
                      </span>
                      <span style="font-size: 14px; font-weight: bold">
                        หมายเลขอ้างอิง1(Ref1) : <br />
                        {{ stu_card_idRef1 }}
                      </span>
                      <br />
                      <span style="font-size: 14px; font-weight: bold">
                        หมายเลขอ้างอิง1(Ref2) : <br />
                        {{ stu_card_idRef2 }}
                      </span>
                    </div>
                    <br />
                  </div>
                  <!-- <div class="alert alert-success">
                  <span class="h2">Payment Success</span>
                  <p>----------------------</p>
                  <p class="text-warning">
                    วิทยาลัยเทคโนโลยีโปลิเทคนิคลานนา เชียงใหม่
                  </p>
                  <p class="font-weight-bold">ขอบคุณสำหรับการชำระเงิน</p>
                  <p>*--------------------*</p>
                </div> -->
                </div>
                <div style="height: 100px"></div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="modal fade"
          id="exampleModalPaysuccess"
          tabindex="-1"
          aria-labelledby="exampleModalLabelPaysuccess"
          aria-hidden="true"
        >
          <div v class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
              <div class="modal-content">
                <div class="alert alert-success my-0 text-center">
                  <span class="h2">Payment Success</span>
                  <p>----------------------</p>
                  <p class="text-warning">
                    วิทยาลัยเทคโนโลยีโปลิเทคนิคลานนา เชียงใหม่
                  </p>
                  <p class="font-weight-bold">ขอบคุณสำหรับการชำระเงิน</p>
                  <p>*--------------------*</p>
                  <p
                    v-for="item in filterDataPrename"
                    :key="item.pre_id"
                    :value="`${item.pre_id}`"
                  >
                    {{ item.pre_prename }}
                    {{ getDataStudent_Test.stu_fname }}
                    {{ getDataStudent_Test.stu_lname }}
                  </p>
                  <p>
                    จำนวนเงิน
                    {{
                      parseFloat(allAmount)
                        .toFixed(2)
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}
                    บาท
                  </p>
                  <p>หมายเลขอ้างอิง</p>
                  <p
                    v-for="item in getDatafinanceBillNoti"
                    :key="item.transactionId"
                    :value="`${item.transactionId}`"
                  >
                    {{ item.transactionId }}
                  </p>
                  <p>ชำระเงินเมื่อ {{ Date_Time_Pay }}</p>
                </div>
                <div v-if="exampleModalStatus4">
                  <div class="alert alert-danger h5 text-center my-0">
                    <label class="col"
                      >กรุณาทำการเลือกวันนัด ทำบัตรประจำตัวนักศึกษา
                      <br />และวัดขนาดรูปร่างของผู้สมัคร เพื่อใช้ตัดชุดนักศึกษา
                      เช่น เดือน/วัน/ปี(ค.ศ.)
                    </label>
                    <div class="row form-group d-flex justify-content-center">
                      <div class="col-lg-8 my-3">
                        <input
                          type="date"
                          class="form-control"
                          v-model="date_appointment"
                          :max="getMaxDate()"
                          :min="getMinDate()"
                          @change="selectDateAppoint"
                        />
                        <!-- {{ getDataFrom6.date_appointment }} -->
                      </div>
                    </div>
                    <div class="row form-group d-flex justify-content-center">
                      <div class="col">
                        <button
                          v-if="getDataFrom6.date_appointment != ''"
                          type="button"
                          class="btn btn-success btn-lg h-75"
                          @click="UpDatedateConf()"
                        >
                          <p>ยืนยันการนัดถ่ายรูป และวัดตัว</p>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="exampleModalStatus5">
                  <div class="alert alert-warning text-left my-0">
                    <div
                      class="form-group img-rounded h4"
                      style="padding: 10px"
                    >
                      <div class="text-center">
                        วันที่นัดวัดขนาดร่างกายเพื่อตัดชุดนักศึกษา
                        และทำบัตรนักศึกษาคือ
                      </div>
                      <div
                        class="h3 text-danger alert alert-info my-3 text-center"
                      >
                        {{ Date_Time_dress }}<br />
                      </div>
                      <pre
                        class="text-danger"
                      >รายละเอียดเอกสารที่ต้องเตรียมมาในวันที่วัดตัวและทำบัตรนักศึกษา
                      <ul class="list-group list-group-flush">
                        <li class="list-group">- สำเนาบัตรประจำตัวประชาชนของผู้สมัคร</li>
                        <li class="list-group">- สำเนาบัตรประจำตัวประชาชนของบิดา</li>
                        <li class="list-group">- สำเนาบัตรประจำตัวประชาชนของมารดา</li>
                        <li class="list-group">- สำเนาทะเบียนบ้านของผู้สมัคร</li>
                        <li class="list-group">- สำเนาทะเบียนบ้านของบิดา</li>
                        <li class="list-group">- สำเนาทะเบียนบ้านของมารดา</li>
                        <li class="list-group">- ใบ ปพ.1 ตัวจริง</li>
                        <li class="list-group">- สำเนาสูติบัตร</li>
                        <li class="list-group">- สำเนาเอกสารการเปลี่ยนชื่อ (ถ้ามี)</li>
                        <li class="list-group">- สำเนาเอกสารการมรณบัตร (กรณีบิดา หรือมารดาเสียชีวิต)</li>
                      </ul>
                    </pre>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="modalBusForStudent"
    tabindex="-1"
    aria-labelledby="modalBusForStudentLabel"
    aria-hidden="true"
  >
    <div v class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content mt-5">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="SetmodalBusForStudentLabel">
            ข้อมูลรถรับส่งนักเรียน
          </h1>
          <button
            ref="CloseModal"
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="row form-group d-flex justify-content-center">
            <div class="col-lg-4 my-3">
              <h6 class="text-left" style="font-weight: bold">
                <div>จังหวัด</div>
              </h6>
              <select
                class="form-select"
                aria-label="Default select example"
                v-model="DataBusForStudent.provinceBus"
                @change="selectProvinceBus()"
              >
                <option
                  value=""
                  selected
                  disabled
                  style="background-color: lightgray"
                >
                  -
                </option>
                <option
                  v-for="item in DataProvinceBus"
                  :key="item.stu_province"
                  :value="item.stu_province"
                >
                  {{ item.pro_name }}
                </option>
              </select>
            </div>
            <div class="col-lg-4 my-3">
              <h6 class="text-left" style="font-weight: bold">
                <div>อำเภอ</div>
              </h6>
              <select
                class="form-select"
                aria-label="Default select example"
                v-model="DataBusForStudent.districtBus"
                @change="selectDistrictBus()"
              >
                <option
                  value=""
                  selected
                  disabled
                  style="background-color: lightgray"
                >
                  -
                </option>
                <option
                  v-for="item in getDataDistrictBus"
                  :key="item.stu_district"
                  :value="item.stu_district"
                >
                  {{ item.dis_name }}
                </option>
              </select>
            </div>
          </div>
          <hr />
          <table
            class="w-100 table table-striped team-roster-table table-hover display nowrap"
            id="TableBusForStudent"
          >
            <thead>
              <tr style="cursor: pointer">
                <th scope="col">อันดับ</th>
                <th scope="col">ชื่อ</th>
                <th scope="col">ตำบล</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in DatalistBusForStudent" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ item.stu_carfollow1 }}</td>
                <td>{{ item.loc_name }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import $ from "jquery";
import QRCode from "qrcode";
import { ref } from "vue";

window.$ = window.jQuery = $;
export default {
  setup() {
    const chartRef = ref(null);

    // ========= set default data chart for chart =========
    const doughnutChart = {
      id: "doughnut",
      type: "doughnut",
      data: {
        labels: ["วันจันทร์", "วันอังคาร", "วันพุธ", "วันพฤหัสบดี"],
        datasets: [
          {
            backgroundColor: ["#41B883", "#E46651", "#00D8FF", "#DD1B16"],
            data: [40, 20, 80, 10],
          },
        ],
      },
      options: {
        cutout: "10%",
        plugins: {},
      },
    };
    // ========= set default data chart for chart =========

    const updateChart = () => {
      doughnutChart.options.plugins.title = {
        display: true,
        text: "Updated ",
      };

      doughnutChart.data.labels.reverse();
      doughnutChart.data.datasets[0].data = [400, 20, 80, 10];
      chartRef.value.update(300); // 300 = animationSpeed
    };

    const exportChart = () => {
      let a = document.createElement("a");
      a.href = chartRef.value.chartJSState.chart.toBase64Image("image/png", 1);
      a.download = "image-export.png";
      a.click();
      a = null;
    };

    return {
      doughnutChart,
      updateChart,
      exportChart,
      chartRef,
    };
  },
  data() {
    return {
      previewImage: "https://www.lannapoly.ac.th/admission/images/logopay2.png",

      stu_sub_relationID: "",
      selectPay: "1",
      conditionSelectPay: false,
      SelectedPay: true,
      ShowQRPay: false,
      payed_full: "",
      payed_total: 0,
      payed_period: "",

      date_appointment: "",

      stu_card_idRef1: "",
      stu_card_idRef2: "",

      Date_Time: "",
      Date_Time_Pay: "",
      Date_Time_dress: "",
      statusPay: "",
      tes_status: "",
      allAmount: "",

      exampleModalStatus4: false,
      exampleModalStatus5: false,

      ourParamId: "",
      TextQrcode: "",

      numForM: "",
      Cardstatus: "",
      CardID: "",
    };
  },
  async mounted() {
    // $("#exampleModalPaysuccess").modal("show");
    // this.exampleModalStatus5 = true;
    if (this.tes_id != "" && this.DateStep.Step1 != "") {
      // get Data Step2
    } else {
      await this.$swal({
        icon: "error",
        title: "Oops...",
        text: "กรุณาดำเนินการขั้นตอน Login ก่อน...",
      });
      this.$store.dispatch("Main/SetStepStatus", 1);
      return;
    }

    if (this.DateStep.Step2 == "") {
      await this.$swal({
        icon: "error",
        title: "Oops...",
        text: "กรุณาบันทึกข้อมูลในขั้นตอนที่ 1 ก่อน...",
      });
      await this.$store.dispatch("Main/SET_Onload", true);
      this.$store.dispatch("Main/SetStepStatus", 2);
      return;
    }
    this.$store.dispatch("Main/SET_Onload", false);
    await this.$store.dispatch("Step6/SetStep6");
    await this.$store.dispatch("Step6/POST_Student_Test");
    await this.$store.dispatch("Step6/POST_StudentTest");
    await this.$store.dispatch("Step6/GET_Version");
    await this.$store.dispatch("Step6/POST_DatafinanceBillNoti");
    this.$store.dispatch("Step6/GET_DataProvince");
    this.$store.dispatch("Step6/POST_DataDistrict");
    this.$store.dispatch("Step6/POST_DataLocality");
    this.$store.dispatch("Step6/GET_DataPrename");
    this.$store.dispatch("Step6/GET_DataOccupationNew");
    this.$store.dispatch("Step6/GET_DataClass");
    this.$store.dispatch("Step6/GET_DataDepartmentStu");
    this.$store.dispatch("Step6/GET_DataSubDepartmentStu");
    this.$store.dispatch("Step6/GET_DataBorrowStu");
    this.$store.dispatch("Step6/GET_DataSignupPayManual");
    this.$store.dispatch("Step6/POST_secret_test");

    $(document).ready(function () {
      $(".IsNumber").keydown(function (e) {
        // Allow: backspace, delete, tab, escape, enter and .
        if (
          $.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
          // Allow: Ctrl+A
          (e.keyCode == 65 && e.ctrlKey === true) ||
          // Allow: home, end, left, right
          (e.keyCode >= 35 && e.keyCode <= 39)
        ) {
          // let it happen, don't do anything
          return;
        }
        // Ensure that it is a number and stop the keypress
        if (
          (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
          (e.keyCode < 96 || e.keyCode > 105)
        ) {
          e.preventDefault();
        }
      });
    });

    // if (this.getDataFrom6.stu_sub_mon != "") {
    //   this.formatCurrency();
    // }

    this.scrollToTop();
    // $("#exampleModal").modal("hide");
    // // $("#exampleModalPayment").modal("hide");
    // $("#exampleModalPaysuccess").modal("hide");

    if (
      this.getDataFrom.stu_card_id.toString()[0] == "G" ||
      this.getDataFrom.stu_card_id.toString()[0] == "g"
    ) {
      this.CardFirst = this.getDataFrom.stu_card_id.toString()[0];
    } else {
      this.getDataFrom6.stu_card_id = this.getDataFrom.stu_card_id;
      this.CardFirst = parseInt(this.getDataFrom.stu_card_id.toString()[0]);

      if (this.CardFirst == 0 || this.CardFirst == 5 || this.CardFirst == 7) {
        this.Cardstatus = true;
      } else {
        this.Cardstatus = false;
      }
    }

    await this.$store.dispatch("Step6/SET_qrcodeChkStatusPay");
    if (this.getqrcodeChkStatusPay.status == false) {
      await this.$swal({
        icon: this.getqrcodeChkStatusPay.type,
        title: this.getqrcodeChkStatusPay.alert,
        text: this.getqrcodeChkStatusPay.text,
      });
    }
    if (this.getqrcodeChkStatusPay.status == "Paysuccess") {
      await this.$store.dispatch("Step6/SET_Stutest_Follow");
      if (this.DataDataStutestFollow.status == false) {
        await this.$swal({
          icon: this.DataDataStutestFollow.type,
          title: this.DataDataStutestFollow.alert,
          text: this.DataDataStutestFollow.text,
        });
      }
    }

    this.stu_card_idRef1 = this.getDataFrom6.tes_id;
    this.stu_card_idRef2 = this.getDataFrom.stu_card_id + "PENR";

    if (this.getqrcodeChkStatusPay.status == "Unsuccess") {
      await this.thaiDate();
      if (this.Cardstatus == false) {
        if (this.CardFirst != "G" && this.CardFirst != "g") {
          if (this.getDataStudentTest.dataPayment[0].tes_status == "2") {
            await this.$store.dispatch("Main/SetStepStatus", 7);
            $("#exampleModal").modal("show");
            $("#exampleModalPayment").modal("hide");
            $("#exampleModalPaysuccess").modal("hide");
          }
        }
      }
    }

    if (this.getqrcodeChkStatusPay.status == "Paysuccess") {
      await this.$store.dispatch("Main/SetStepStatus", 7);
      await this.thaiDate();

      if (this.getDataStudentTest.dataPayment[0].tes_status == "1") {
        $("#exampleModal").modal("hide");
        $("#exampleModalPayment").modal("hide");
        $("#exampleModalPaysuccess").modal("show");
        this.getDataStudentTest.dataPayment[0].tes_status = "4";
      }
      if (this.getDataStudentTest.dataPayment[0].tes_status == "4") {
        $("#exampleModal").modal("hide");
        $("#exampleModalPayment").modal("hide");
        $("#exampleModalPaysuccess").modal("show");
        this.exampleModalStatus4 = true;
        this.exampleModalStatus5 = false;
      } else if (this.getDataStudentTest.dataPayment[0].tes_status == "5") {
        $("#exampleModal").modal("hide");
        $("#exampleModalPayment").modal("hide");
        $("#exampleModalPaysuccess").modal("show");
        this.exampleModalStatus4 = false;
        this.exampleModalStatus5 = true;
      }
    }

    if (this.getDataFrom6.stu_sub_relation == "บิดา") {
      this.stu_sub_relationID = 1;
    } else if (this.getDataFrom6.stu_sub_relation == "มารดา") {
      this.stu_sub_relationID = 2;
    } else if (this.getDataFrom6.stu_sub_relation == "") {
      this.stu_sub_relationID = "";
    } else {
      this.stu_sub_relationID = 0;
    }
  },
  beforeUnmount() {
    clearInterval(this.interval);
  },
  watch: {
    DatalistBusForStudent: {
      async handler() {
        await $("#TableBusForStudent").DataTable().destroy();
        await $("#TableBusForStudent").DataTable({
          pageLength: 100,
          responsive: true,
          scrollX: true,
        });
        //alert("OK");
      },
      deep: true,
    },
  },
  methods: {
    maxSalarySub(event) {
      const value = event.target.value;
      if (value.length > 6) {
        this.getDataFrom6.stu_sub_mon = value.slice(0, 6); // ตัดตัวเลขส่วนเกินออก
      }
    },
    async loadPostCode(name) {
      if (name == "SLocality") {
        for (const item of this.getDataLocality) {
          if (item.loc_id == this.getDataFrom6.stu_slocality) {
            this.getDataFrom6.stu_spostcode = item.post_code;
            break;
          } else {
            this.getDataFrom6.stu_spostcode = "";
          }
        }
      }
    },
    closeExampleModal() {
      $("#exampleModal").modal("hide");
    },
    async showModalBusForStudent() {
      await this.$store.dispatch("Step6/GET_DataProvinceBus");
      this.DataBusForStudent.provinceBus =
        this.DataProvinceBus?.length > 0
          ? this.DataProvinceBus[0].stu_province
          : "";
      await this.$store.dispatch("Step6/POST_DataDistrictBus");
      this.DataBusForStudent.districtBus =
        this.getDataDistrictBus?.length > 0
          ? this.getDataDistrictBus[0].stu_district
          : "";
      await $("#modalBusForStudent").modal("show");
      await this.$store.dispatch("Step6/POST_DataBusForStudent");
    },
    closeModalBusForStudent() {
      $("#modalBusForStudent").modal("hide");
    },
    getMinDate() {
      const currentDate = new Date();
      currentDate.setFullYear(currentDate.getFullYear());
      const dateTest = currentDate.toISOString().split("T")[0];
      const Year = parseInt(dateTest.split("-")[0]);
      const month = dateTest.split("-")[1];
      const day = dateTest.split("-")[2];
      const thaiDate = `${Year}-${month}-${day}`;
      return thaiDate;
    },
    getMaxDate() {
      const currentDate = new Date();
      currentDate.setFullYear(currentDate.getFullYear());
      const dateTest = currentDate.toISOString().split("T")[0];
      const Year = parseInt(dateTest.split("-")[0]) + 1;
      const month = dateTest.split("-")[1];
      const day = dateTest.split("-")[2];
      const thaiDate = `${Year}-${month}-${day}`;
      return thaiDate;
    },
    // getMinDate() {
    //   return "2507-01-01";
    // },
    selectDateAppoint() {
      const date = new Date(this.date_appointment);
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();

      const formattedDate = `${year}-${month}-${day}`;
      // this.updatedDate = formattedDate;
      this.getDataFrom6.date_appointment = formattedDate;
    },
    async checkStatPay() {
      if (
        this.filterDataSignupPayManualsix != "" &&
        this.filterDataSignupPayManualsix != null
      ) {
        if (
          this.getDatasecret_test.cla_id != "" &&
          this.getDatasecret_test.fac_id != "" &&
          this.getDatasecret_test.dep_id != "" &&
          this.getDatasecret_test.sdep_id != "" &&
          this.getDatasecret_test.cla_id != null &&
          this.getDatasecret_test.fac_id != null &&
          this.getDatasecret_test.dep_id != null &&
          this.getDatasecret_test.sdep_id != null
        ) {
          await this.$store.dispatch("Step6/POST_StudentTest");
          if (this.getDataStudentTest.dataPayment[0].tes_status == "2") {
            this.interval = setInterval(() => {
              this.$store.dispatch("Step6/SET_qrcodeChkStatusPay");
              this.$store.dispatch("Main/SET_Onload", false);
              if (this.getqrcodeChkStatusPay.status == "Paysuccess") {
                this.thaiDate();
                clearInterval(this.interval);
                this.$store.dispatch("Step6/SET_Stutest_Follow");
                if (this.DataDataStutestFollow.status == false) {
                  this.$swal({
                    icon: this.DataDataStutestFollow.type,
                    title: this.DataDataStutestFollow.alert,
                    html: `${this.DataDataStutestFollow.text}<br><a href="https://m.me/lannapolyCNX" target="_blank" style="color: blue; text-decoration: none;">Facebook Messenger</a>/<a href="https://line.me/ti/p/~@lannapoly" target="_blank" style="color: blue; text-decoration: none;">Line</a>`,
                  });
                }
              } else if (this.getqrcodeChkStatusPay.status == false) {
                this.$swal({
                  icon: this.getqrcodeChkStatusPay.type,
                  title: this.getqrcodeChkStatusPay.alert,
                  html: `${this.getqrcodeChkStatusPay.text}<br><a href="https://m.me/lannapolyCNX" target="_blank" style="color: blue; text-decoration: none;">Facebook Messenger</a>/<a href="https://line.me/ti/p/~@lannapoly" target="_blank" style="color: blue; text-decoration: none;">Line</a>`,
                });
                return;
              } else if (
                $("#exampleModalPayment").modal()[0].ariaModal == null
              ) {
                clearInterval(this.interval);
              }
              // test Modal show and hide
              // if ($("#exampleModal").modal().length == 1) {
              //   console.log($("#exampleModal").modal()[0].ariaModal);
              // } else if ($("#exampleModal").modal().length == 0) {
              //   console.log("Fail");
              // }
            }, 3000);
          }
        }
      }
      this.$store.dispatch("Main/SET_Onload", true);
    },
    Pay_All_select() {
      // this.Tx_Amount = "1";
      this.Rele = "000201";
      this.intitial = "010212";

      this.Tx_AID = "A000000677010112";
      this.Aid = "00" + this.Tx_AID.length;
      this.Total_AID = this.Aid + this.Tx_AID;

      this.Tx_BIller = "050554200178110";
      this.BIller = "01" + this.Tx_BIller.length;
      this.Total_BIller = this.BIller + this.Tx_BIller;

      this.Tx_Re1 = this.getDataFrom6.tes_id.trim();
      this.Re1 = "02" + this.Tx_Re1.length;
      if (this.Tx_Re1.length >= 10) {
        this.Re1 = "02" + this.Tx_Re1.length;
      } else {
        this.Re1 = "020" + this.Tx_Re1.length;
      }
      this.Total_Re1 = this.Re1 + this.Tx_Re1;

      this.Tx_Re2 = this.stu_card_idRef2.trim();
      this.Re2 = "03" + this.Tx_Re2.length;
      if (this.Tx_Re2.length >= 10) {
        this.Re2 = "03" + this.Tx_Re2.length;
      } else {
        this.Re2 = "030" + this.Tx_Re2.length;
      }
      this.Total_Re2 = this.Re2 + this.Tx_Re2;

      this.total_QR =
        this.Aid +
        this.Tx_AID +
        this.BIller +
        this.Tx_BIller +
        this.Re1 +
        this.Tx_Re1 +
        this.Re2 +
        this.Tx_Re2;

      this.Qr = "30" + this.total_QR.length;

      this.Curr = "5303764";
      this.Country = "5802TH";
      this.Addit = "";
      this.crc = "6304";

      this.Tx_Terminal = "SCB001";

      if (this.Tx_Terminal.length >= "10") {
        this.Terminal = "07" + this.Tx_Terminal.length;
      } else {
        this.Terminal = "070" + this.Tx_Terminal.length;
      }
      this.Total_Terminal = this.Terminal + this.Tx_Terminal;

      this.Tx_Amount = this.payed_total;
      this.Tx_Amount = this.Tx_Amount.replace(",", "");
      if (String(this.Tx_Amount).length >= "10") {
        this.Amount = "54" + String(this.Tx_Amount).length;
      } else {
        this.Amount = "540" + String(this.Tx_Amount).length;
      }

      this.total_Amount = this.Amount + this.Tx_Amount;

      this.ourParamId =
        this.Rele +
        this.intitial +
        this.Qr +
        this.Total_AID +
        this.Total_BIller +
        this.Total_Re1 +
        this.Total_Re2 +
        this.Curr +
        this.total_Amount +
        this.Country +
        this.Addit +
        this.Total_Terminal +
        this.crc;

      this.CrcCode = this.stringToHex(this.ourParamId);
      this.TextQrcode = this.ourParamId + this.CrcCode;
    },
    async generateQRCode(TextQrcode) {
      if (
        this.getDatasecret_test.cla_id != "" &&
        this.getDatasecret_test.fac_id != "" &&
        this.getDatasecret_test.dep_id != "" &&
        this.getDatasecret_test.sdep_id != "" &&
        this.getDatasecret_test.cla_id != null &&
        this.getDatasecret_test.fac_id != null &&
        this.getDatasecret_test.dep_id != null &&
        this.getDatasecret_test.sdep_id != null
      ) {
        if (
          this.filterDataSignupPayManualsix != "" &&
          this.filterDataSignupPayManualsix != null
        ) {
          const canvas = this.$refs.qrcodeCanvas;
          QRCode.toCanvas(canvas, TextQrcode, { scale: 5.5 }, (error) => {
            if (error) {
              console.error(error);
            } else {
              canvas.classList.add("border_pay");
            }
          });
          try {
            const response = await window.Axios.post(
              `${window.api}post/logQRCode/`,
              {
                dataRef1: this.stu_card_idRef1,
                dataRef2: this.stu_card_idRef2,
                StuName: this.getDataStudent_Test.stu_fnam,
                Tel: this.getDataStudent_Test.stu_sms_stu,
                TextQrcode: TextQrcode,
              }
            );
            console.log(response);
          } catch (error) {
            console.error(error);
          }
          // const dataURL = canvas.toDataURL();
          // this.saveQRCodeToAssets(dataURL, "qrcode.png");
        } else {
          this.$swal({
            icon: "error",
            title: "Oops...",
            html: "ประเภทการสมัครที่นักศึกษาเลือกไว้เต็มจำนวนแล้ว กรุณาเลือกใหม่<br />ในขั้นตอนที่ 1",
          });
        }
      } else {
        this.$swal({
          icon: "error",
          title: "Oops...",
          text: "กรุณากรอกข้อมูลใน 'ขั้นตอนที่ 1' ให้ครบถ้วน",
        });
      }
    },
    saveQRCodeToAssets(dataURL, filename) {
      const link = document.createElement("a");
      link.href = dataURL;
      link.download = `../../assets/${filename}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    stringToHex(data) {
      const CRC16Normal = "0x1021";
      let crc = 0xffff;

      for (let i = 0; i < data.length; i++) {
        let byte = data.charCodeAt(i);
        crc ^= byte << 8;

        for (let j = 0; j < 8; j++) {
          if (crc & 0x8000) {
            crc = (crc << 1) ^ CRC16Normal;
          } else {
            crc = crc << 1;
          }
        }
      }

      crc = crc & 0xffff;
      let result = "";

      const hexChar = crc.toString(16);
      result += hexChar.padStart(4, "0");
      result = result.toUpperCase();

      return result;
    },
    async QRPay() {
      if (
        this.getDatasecret_test.cla_id != "" &&
        this.getDatasecret_test.fac_id != "" &&
        this.getDatasecret_test.dep_id != "" &&
        this.getDatasecret_test.sdep_id != "" &&
        this.getDatasecret_test.cla_id != null &&
        this.getDatasecret_test.fac_id != null &&
        this.getDatasecret_test.dep_id != null &&
        this.getDatasecret_test.sdep_id != null
      ) {
        if (
          this.filterDataSignupPayManualsix != "" &&
          this.filterDataSignupPayManualsix != null
        ) {
          if (this.getqrcodeChkStatusPay.status == "Unsuccess") {
            $("#exampleModal").modal("hide");
            $("#exampleModalPayment").modal("show");
            $("#exampleModalPaysuccess").modal("hide");
          }
        } else {
          $("#exampleModal").modal("show");
          $("#exampleModalPayment").modal("hide");
          $("#exampleModalPaysuccess").modal("hide");
        }
      } else {
        $("#exampleModal").modal("show");
        $("#exampleModalPayment").modal("hide");
        $("#exampleModalPaysuccess").modal("hide");
      }
      this.ShowQRPay = true;
    },
    conditionSell() {
      if (this.conditionSelectPay == true) {
        this.SelectedPay = false;
      } else if (this.conditionSelectPay == false) {
        this.SelectedPay = true;
      }
    },
    getTotal() {
      let total = 0;
      if (this.selectPay == 1) {
        for (let i = 0; i < this.filterDataSignupPayManualsix.length; i++) {
          total += parseFloat(this.filterDataSignupPayManualsix[i].pay_full);
        }
        total = parseFloat(total)
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.payed_total = total;
        return this.payed_total;
      } else if (this.selectPay == 2) {
        for (let i = 0; i < this.filterDataSignupPayManualsix.length; i++) {
          total += parseFloat(this.filterDataSignupPayManualsix[i].pay_period);
        }
        total = parseFloat(total)
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.payed_total = total;
        return this.payed_total;
      }
    },
    async stu_sub_relationIF() {
      const From6 = this.getDataFrom6;
      const StuTest = this.getDataStudentTest.dataPayment[0];

      if (this.stu_sub_relationID == 1) {
        this.getDataFrom6.stu_sub_relation = "บิดา";
        StuTest.father_prename
          ? (From6.stu_sub_prename = StuTest.father_prename.trim())
          : "";
        From6.stu_sub_fname = StuTest.stu_father_fname;
        From6.stu_sub_lname = StuTest.stu_father_lname;
        From6.stu_shomeid = StuTest.stu_homid_f;
        From6.stu_ssoi = StuTest.stu_soi_f;
        From6.stu_sroad = StuTest.stu_road_f;
        StuTest.stu_province_f
          ? (From6.stu_sprovince = StuTest.stu_province_f.trim())
          : "";
        await this.$store.dispatch("Step6/POST_DataDistrict");
        From6.stu_sdistrict = StuTest.stu_district_f;
        await this.$store.dispatch("Step6/POST_DataLocality");
        From6.stu_slocality = StuTest.stu_local_f;
        From6.stu_spostcode = StuTest.stu_postcode_f;
        From6.stu_sub_occ = StuTest.stu_fat_occ;
        From6.stu_sms = StuTest.stu_phone_f;
        this.numForM = StuTest.stu_fat_mon;

        if (this.numForM != "" && this.numForM != null) {
          const value = this.numForM.replace(/,/g, "");
          const modifiedValue = value;
          const formattedValue = parseFloat(modifiedValue)
            .toFixed(2)
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          this.numForM = formattedValue;
          From6.stu_sub_mon = From6.stu_sub_mon.split(".")[0];
        } else {
          this.numForM = "";
        }
        From6.stu_sub_plan = StuTest.stu_fathe_wplace;
        From6.stu_sub_phoneplan = StuTest.stu_fplace_phone;
      } else if (this.stu_sub_relationID == 2) {
        this.getDataFrom6.stu_sub_relation = "มารดา";
        StuTest.mother_prename
          ? (From6.stu_sub_prename = StuTest.mother_prename.trim())
          : "";
        From6.stu_sub_fname = StuTest.stu_mother_fname;
        From6.stu_sub_lname = StuTest.stu_mother_lname;
        From6.stu_shomeid = StuTest.stu_homid_m;
        From6.stu_ssoi = StuTest.stu_soi_m;
        From6.stu_sroad = StuTest.stu_road_m;
        StuTest.stu_province_m
          ? (From6.stu_sprovince = StuTest.stu_province_m.trim())
          : "";
        await this.$store.dispatch("Step6/POST_DataDistrict");
        From6.stu_sdistrict = StuTest.stu_district_m;
        await this.$store.dispatch("Step6/POST_DataLocality");
        From6.stu_slocality = StuTest.stu_local_m;
        From6.stu_spostcode = StuTest.stu_postcode_m;
        From6.stu_sub_occ = StuTest.stu_mom_occ;
        From6.stu_sms = StuTest.stu_phone_m;
        this.numForM = StuTest.stu_mom_mon1;
        if (this.numForM != "" && this.numForM != null) {
          const value = this.numForM.replace(/,/g, "");
          const modifiedValue = value;
          const formattedValue = parseFloat(modifiedValue)
            .toFixed(2)
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          this.numForM = formattedValue;
          From6.stu_sub_mon = From6.stu_sub_mon.split(".")[0];
        }
        From6.stu_sub_plan = StuTest.stu_mother_wplace;
        From6.stu_sub_phoneplan = StuTest.stu_mplace_phone;
      } else if (this.stu_sub_relationID == 0) {
        this.getDataFrom6.stu_sub_relation = "";
        From6.stu_sub_prename = "";
        From6.stu_sub_fname = "";
        From6.stu_sub_lname = "";
        From6.stu_shomeid = "";
        From6.stu_ssoi = "";
        From6.stu_sroad = "";
        From6.stu_sprovince = "";
        From6.stu_sdistrict = "";
        From6.stu_slocality = "";
        From6.stu_spostcode = "";
        From6.stu_sphone = "";
        From6.stu_sms = "";
        From6.stu_sub_occ = "";
        this.numForM = "";
        From6.stu_sub_mon = "";
        From6.stu_sub_plan = "";
        From6.stu_sub_phoneplan = "";
      }
    },
    async thaiDate() {
      await this.$store.dispatch("Step6/POST_DatafinanceBillNoti");
      if ((await this.getDatafinanceBillNoti.thaiDate[0]) != "") {
        this.Date_Time_Pay = this.getDatafinanceBillNoti.thaiDate[0];
        this.allAmount = this.getDatafinanceBillNoti.dataPayment[0].amount;
        this.Date_Time_dress = this.getDataStudentTest.thaiDate[0];
      }
      if (this.getqrcodeChkStatusPay.status == "Paysuccess") {
        if (this.getDataStudentTest.dataPayment[0].tes_status == "2") {
          $("#exampleModal").modal("hide");
          $("#exampleModalPayment").modal("hide");
          $("#exampleModalPaysuccess").modal("show");
          this.getDataStudentTest.dataPayment[0].tes_status = "4";
          if (this.getDataStudentTest.dataPayment[0].tes_status == "4") {
            this.exampleModalStatus4 = true;
            this.exampleModalStatus5 = false;
          }
        }
      }
    },
    async UpDatedateConf() {
      this.$store.dispatch("Main/SET_Onload", false);
      if (this.getDataStudentTest.dataPayment[0].tes_status == "4") {
        const date = new Date(this.date_appointment);
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear();

        const currentDateMin = new Date();
        currentDateMin.setFullYear(currentDateMin.getFullYear());
        const dateTestMin = currentDateMin.toISOString().split("T")[0];
        const YearMin = parseInt(dateTestMin.split("-")[0]);
        const YearMax = parseInt(dateTestMin.split("-")[0]) + 1;

        if (
          day != "" &&
          month != "" &&
          year != "" &&
          day != "NaN" &&
          month != "NaN" &&
          year != "NaN" &&
          year >= YearMin &&
          year <= YearMax
        ) {
          await this.$store.dispatch("Step6/SET_DatedateConf");
          if (this.DataDatedateConf.status == false) {
            await this.$swal({
              icon: this.DataDatedateConf.type,
              title: this.DataDatedateConf.alert,
              html: `${this.DataDatedateConf.text}<br><a href="https://m.me/lannapolyCNX" target="_blank" style="color: blue; text-decoration: none;">Facebook Messenger</a>/<a href="https://line.me/ti/p/~@lannapoly" target="_blank" style="color: blue; text-decoration: none;">Line</a>`,
            });
          }
          await this.$store.dispatch("Step6/POST_StudentTest");
        } else {
          await this.$swal({
            icon: "error",
            title: "Oops...",
            text: "วัน เดือน ปี ค.ศ. ไม่ถูกต้อง กรุณาตรวจสอบอีกครั้ง",
          });
        }
        if (this.getDataStudentTest.dataPayment[0].tes_status == "5") {
          await this.thaiDate();
          $("#exampleModal").modal("hide");
          $("#exampleModalPayment").modal("hide");
          $("#exampleModalPaysuccess").modal("show");
          this.exampleModalStatus4 = false;
          this.exampleModalStatus5 = true;
        }
      } else {
        await this.$swal({
          icon: "error",
          title: "Oops...",
          text:
            "Error Code " + this.getDataStudentTest.dataPayment[0].tes_status,
        });
      }
    },
    // formatCurrency() {
    //   // แปลงค่าที่รับเข้ามาให้เป็นรูปแบบเลขที่มี , คั่น
    //   const From6 = this.getDataFrom6;

    //   if (this.numForM.includes(",")) {
    //     const S_mon_array = this.numForM.split(",");
    //     this.numForM = S_mon_array[0] + S_mon_array[1];
    //   }

    //   if (From6.stu_sub_mon == ".00" || From6.stu_sub_mon == "00") {
    //     if (this.numForM != ".00" && this.numForM != "00") {
    //       From6.stu_sub_mon = this.numForM;
    //       // From6.stu_sub_mon =
    //       //   From6.stu_sub_mon.split(",")[0] + From6.stu_sub_mon.split(",")[1];
    //       const value = From6.stu_sub_mon.replace(/,/g, "");
    //       const modifiedValue = value;
    //       const formattedValue = parseFloat(modifiedValue)
    //         .toFixed(2)
    //         .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    //       this.numForM = formattedValue;
    //     } else {
    //       From6.stu_sub_mon = "";
    //       this.numForM = "";
    //     }

    //     return;
    //   } else if (this.numForM != "" && this.numForM != null) {
    //     From6.stu_sub_mon = this.numForM;
    //     // From6.stu_sub_mon =
    //     //   From6.stu_sub_mon.split(",")[0] + From6.stu_sub_mon.split(",")[1];
    //     const value = From6.stu_sub_mon.replace(/,/g, "");
    //     const modifiedValue = value;
    //     const formattedValue = parseFloat(modifiedValue)
    //       .toFixed(2)
    //       .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    //     this.numForM = formattedValue;
    //   } else {
    //     this.numForM;
    //     From6.stu_sub_mon = ".00";
    //   }
    // },

    async selectProvince() {
      this.$store.dispatch("Main/SET_Onload", false);
      await this.$store.dispatch("Step6/POST_DataDistrict");
      await this.$store.dispatch("Step6/POST_DataLocality");
      this.loadPostCode("SLocality");
    },
    async selectProvinceBus() {
      this.$store.dispatch("Main/SET_Onload", false);
      await this.$store.dispatch("Step6/POST_DataDistrictBus");
      this.DataBusForStudent.districtBus =
        this.getDataDistrictBus?.length > 0
          ? this.getDataDistrictBus[0].stu_district
          : "";
      await this.$store.dispatch("Step6/POST_DataBusForStudent");
    },
    async selectDistrictBus() {
      await this.$store.dispatch("Main/SET_Onload", false);
      await this.$store.dispatch("Step6/POST_DataBusForStudent");
    },
    async selectDistrict() {
      await this.$store.dispatch("Main/SET_Onload", false);
      await this.$store.dispatch("Step6/POST_DataLocality");
      this.loadPostCode("SLocality");
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth", // เพื่อให้การเลื่อนเป็นแบบนุ่มนวล
      });
    },
    async SetStepStatusback(payload) {
      this.$store.dispatch("Main/SetStepStatus", payload);
    },
    async SetStepStatus(payload) {
      await this.$store.dispatch("Step1/SetStepStatus");
      this.SelectedPay = true;
      if (
        this.DateStep.Step1 != "" &&
        this.DateStep.Step2 != "" &&
        this.DateStep.Step3 != "" &&
        this.DateStep.Step4 != "" &&
        this.DateStep.Step5 != ""
      ) {
        this.ShowQRPay = false;
        this.conditionSelectPay = false;

        if (this.getDataFrom6.stu_sub_mon == "") {
          this.getDataFrom6.stu_sub_mon = ".00";
        }
        if (
          this.getDatasecret_test.cla_id != "" &&
          this.getDatasecret_test.fac_id != "" &&
          this.getDatasecret_test.dep_id != "" &&
          this.getDatasecret_test.sdep_id != "" &&
          this.getDatasecret_test.cla_id != null &&
          this.getDatasecret_test.fac_id != null &&
          this.getDatasecret_test.dep_id != null &&
          this.getDatasecret_test.sdep_id != null
        ) {
          if (
            this.filterDataSignupPayManualsix != "" &&
            this.filterDataSignupPayManualsix != null
          ) {
            await this.$store.dispatch("Step6/SetStepStatus");
            if (this.Cardstatus == true && this.CardID == "") {
              await this.$swal({
                icon: "error",
                title: "Oops...",
                text: "กรุณาเลือกรูปแบบบัตรประชาชน",
              });
            } else if (
              (this.Cardstatus == true && this.CardID == "N") ||
              this.CardFirst == "G" ||
              this.CardFirst == "g" ||
              this.getDataStudent_Test.stu_tattoo == "2"
            ) {
              const timestamp = new Date().getTime();

              let ButtonPayment = true;
              // console.log(this.getDataFrom3);

              if (this.getDataStudent_Test.stu_tattoo == "2") {
                ButtonPayment = false;
              }
              // ${window.qrcode}qrcode_line${this.getDataFrom6.select_year}.jpg?${timestamp}
              // html: '<span style="color: red;font-size: 22px;">กรุณาชำระเงินด้วยตนเอง ณ วิทยาลัยฯ (ชำระก่อนได้สิทธิ์ก่อน โควต้ามีจำนวนจำกัด)</span>',
              // await this.$swal({
              //   icon: "success",
              //   title: "Success!!",
              //   html:
              //     "โปรด scan qrcode ข้างต้นเพื่อเข้าสู่กลุ่มนักศึกษาใหม่<br>ของวิทยาลัยฯ ปีการศึกษา " +
              //     this.getDataStudentTest.dataPayment[0].stu_year_entry,
              //   confirmButtonText: "ชำระค่าธรรมเนียมการศึกษา",
              //   imageUrl: `${window.qrcode}qrcode_line${this.getDataFrom6.select_year}.jpg?${timestamp}`,
              //   imageHeight: 300,
              //   imageWidth: 300,
              // });
              await this.$swal({
                icon: "success",
                title: "Success!!",
                html:
                  "โปรด scan qrcode ข้างต้นเพื่อเข้าสู่กลุ่มนักศึกษาใหม่<br>ของวิทยาลัยฯ ปีการศึกษา " +
                  this.getDataStudentTest.dataPayment[0].stu_year_entry,
                confirmButtonText: "ชำระค่าธรรมเนียมการศึกษา",
                showConfirmButton: ButtonPayment,
                imageUrl: `${window.qrcode}qrcode_line${this.getDataFrom6.select_year}.jpg?${timestamp}`,
                imageHeight: 300,
                imageWidth: 300,
              }).then(async (result) => {
                if (result.isConfirmed) {
                  if (this.getqrcodeChkStatusPay.status == "Unsuccess") {
                    $("#exampleModal").modal("show");
                    // $("#exampleModalPayment").modal("hide");
                    $("#exampleModalPaysuccess").modal("hide");
                  } else if (
                    this.getqrcodeChkStatusPay.status == "Paysuccess"
                  ) {
                    if (
                      this.getDataStudentTest.dataPayment[0].tes_status == "4"
                    ) {
                      $("#exampleModal").modal("hide");
                      $("#exampleModalPayment").modal("hide");
                      $("#exampleModalPaysuccess").modal("show");
                      this.exampleModalStatus4 = true;
                      this.exampleModalStatus5 = false;
                    } else if (
                      this.getDataStudentTest.dataPayment[0].tes_status == "5"
                    ) {
                      $("#exampleModal").modal("hide");
                      $("#exampleModalPayment").modal("hide");
                      $("#exampleModalPaysuccess").modal("show");
                      this.exampleModalStatus4 = false;
                      this.exampleModalStatus5 = true;
                    }
                    // this.checkStatPay();
                  }
                }
              });
            } else {
              this.$store.dispatch("Main/SetStepStatus", payload);
              if (this.DateStep6.status == true) {
                const timestamp = new Date().getTime();
                let ButtonPayment = true;
                // console.log(this.getDataFrom3);

                if (this.getDataStudent_Test.stu_tattoo == "2") {
                  ButtonPayment = false;
                }
                await this.$swal({
                  icon: "success",
                  title: "Success!!",
                  html:
                    "โปรด scan qrcode ข้างต้นเพื่อเข้าสู่กลุ่มนักศึกษาใหม่<br>ของวิทยาลัยฯ ปีการศึกษา " +
                    this.getDataStudentTest.dataPayment[0].stu_year_entry,
                  confirmButtonText: "ชำระค่าธรรมเนียมการศึกษา",
                  showConfirmButton: ButtonPayment,
                  imageUrl: `${window.qrcode}qrcode_line${this.getDataFrom6.select_year}.jpg?${timestamp}`,
                  imageHeight: 300,
                  imageWidth: 300,
                }).then(async (result) => {
                  if (result.isConfirmed) {
                    if (this.getqrcodeChkStatusPay.status == "Unsuccess") {
                      $("#exampleModal").modal("show");
                      // $("#exampleModalPayment").modal("hide");
                      $("#exampleModalPaysuccess").modal("hide");
                    } else if (
                      this.getqrcodeChkStatusPay.status == "Paysuccess"
                    ) {
                      if (
                        this.getDataStudentTest.dataPayment[0].tes_status == "4"
                      ) {
                        $("#exampleModal").modal("hide");
                        $("#exampleModalPayment").modal("hide");
                        $("#exampleModalPaysuccess").modal("show");
                        this.exampleModalStatus4 = true;
                        this.exampleModalStatus5 = false;
                      } else if (
                        this.getDataStudentTest.dataPayment[0].tes_status == "5"
                      ) {
                        $("#exampleModal").modal("hide");
                        $("#exampleModalPayment").modal("hide");
                        $("#exampleModalPaysuccess").modal("show");
                        this.exampleModalStatus4 = false;
                        this.exampleModalStatus5 = true;
                      }
                      // this.checkStatPay();
                    }
                  }
                });
              } else if (this.DateStep6.status == false) {
                await this.$swal({
                  icon: this.DateStep6.type,
                  title: this.DateStep6.alert,
                  html: `${this.DateStep6.text}<br><a href="https://m.me/lannapolyCNX" target="_blank" style="color: blue; text-decoration: none;">Facebook Messenger</a>/<a href="https://line.me/ti/p/~@lannapoly" target="_blank" style="color: blue; text-decoration: none;">Line</a>`,
                });
              }
            }
          } else {
            await this.$swal({
              icon: "error",
              title: "Oops...",
              html: "ประเภทการสมัครที่นักศึกษาเลือกไว้เต็มจำนวนแล้ว<br />กรุณาเลือกใหม่ ในขั้นตอนที่ 1 / 2",
            });
          }
        } else {
          await this.$swal({
            icon: "error",
            title: "Oops...",
            text: "กรุณากรอกข้อมูลใน 'ขั้นตอนที่ 1' ให้ครบถ้วน",
          });
        }
      } else {
        await this.$swal({
          icon: "error",
          title: "Oops...",
          text: "กรอกข้อมูลขั้นตอนที่1 ถึง ขั้นตอนที่4 ให้ครบถ้วน",
        });
      }
    },
  },
  computed: {
    filterDataPrename() {
      return this.getDataPrename.filter(
        (item) => item.pre_id == this.getDataStudent_Test.pre_id
      );
    },
    filterDataVersion() {
      return this.getDataVersion.filter(
        (item) => item.ver_id.trim() == this.getDataStudent_Test.ver_id.trim()
      );
    },
    filterEducateLevelsix() {
      return this.DataClass.filter(
        (item) => item.cla_id == this.getDataStudent_Test.cla_id
      );
    },
    filterDepartMentStusix() {
      return this.DataSubDepartmentStu.filter(
        (item) =>
          item.sdepActive == "1" &&
          item.cla_id == this.getDataStudent_Test.cla_id &&
          (item.fac_id
            ? item.fac_id.trim() == this.getDataStudent_Test.fac_id
            : "") &&
          item.dep_id == this.getDataStudent_Test.dep_id &&
          item.sdep_id == this.getDataStudent_Test.sdep_id
      );
    },
    filterDataBorrowStusix() {
      var cap_ids = this.getDataStudent_Test.cap_id
        ? this.getDataStudent_Test.cap_id.split("|")
        : "";

      var btId = cap_ids[0];
      var bnId = cap_ids[1];

      return this.DataBorrowStu.filter(
        (item) =>
          item.cla_id == this.getDataStudent_Test.cla_id &&
          item.sdep_id == this.getDataStudent_Test.sdep_id &&
          item.dep_id == this.getDataStudent_Test.dep_id &&
          (this.getDataStudent_Test.fac_id
            ? item.fac_id == this.getDataStudent_Test.fac_id.trim()
            : "") &&
          item.bt_id == btId &&
          item.bn_id == bnId
      );
    },
    filterDataSignupPayManualsix() {
      var cap_ids = this.getDataStudent_Test.cap_id
        ? this.getDataStudent_Test.cap_id.split("|")
        : "";

      var btId = cap_ids[0];
      var bnId = cap_ids[1];

      return this.DataSignupPayManual.filter(
        (item) =>
          item.cla_id == this.getDataStudent_Test.cla_id &&
          item.sdep_id == this.getDataStudent_Test.sdep_id &&
          item.dep_id == this.getDataStudent_Test.dep_id &&
          item.fac_id.trim() === this.getDataStudent_Test.fac_id.trim() &&
          item.bt_id == btId &&
          item.bn_id == bnId
      );
    },
    ...mapGetters({
      _getStepIndex: "Main/_getStepIndex",
      tes_id: "Main/_getTesID",
      DateStep: "Main/_getDateStep",
      DateStep6: "Main/_getDateStep6",
      DataBusForStudent: "Step6/_getDataBusForStudent",
      getDataFrom6: "Step6/_getDataFrom6",
      getDataFrom: "Step1/_getDataFrom",
      getDataFrom3: "Step3/_getDataFrom3",
      DataClass: "Step6/_getDataClass",
      DataDepartmentStu: "Step6/_getDataDepartmentStu",
      DataSubDepartmentStu: "Step6/_getDataSubDepartmentStu",
      DataBorrowStu: "Step6/_getDataBorrowStu",
      DataSignupPayManual: "Step6/_getDataSignupPayManual",
      getDataPrename: "Step6/_getDataprename",
      getDataDistrictBus: "Step6/_getDataDistrictBus",
      getDataLocalityBus: "Step6/_getDataLocalityBus",
      getDataProvince: "Step6/_getDataProvince",
      getDataDistrict: "Step6/_getDataDistrict",
      getDataLocality: "Step6/_getDataLocality",
      getDataOccupationNew: "Step6/_getDataOccupationNew",
      getqrcodeChkStatusPay: "Step6/_getqrcodeChkStatusPay",
      getLoadingSTATUS: "Step6/_LoadingSTATUS",
      getDatafinanceBillNoti: "Step6/_getfinanceBillNoti",
      getDataStudentTest: "Step6/_getDataStudentTest",
      getDataStudent_Test: "Step6/_getDataStudent_Test",
      getDatasecret_test: "Step6/_getDatasecret_test",
      getDataVersion: "Step6/_getDataVersion",
      DataDatedateConf: "Step6/_getDataDatedateConf",
      DataDataStutestFollow: "Step6/_getDataStutestFollow",
      DatalistBusForStudent: "Step6/_getlistBusForStudent",
      DataProvinceBus: "Step6/_getDataProvinceBus",

      getDataStepFrom1: "Step1/_getDataStepFrom1",
    }),
  },
};
</script>

<style>
.border_pay {
  display: block;
  border: 4px solid #0e3d67;
  border-width: thick;
  margin-left: auto;
  margin-right: auto;
}
.link {
  text-decoration: none;
}
.link:hover {
  text-decoration: underline;
}
</style>
